export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfABc4EsA.woff2";